<ng-container *ngIf="liveStreamDetails">
	<div class="bb-streams-wrapper">
		<h2>{{ "STREAM_DETAILS" | translate }}</h2>
		<div class="line">
			<label>{{ "TYPE" | translate }}</label>
			<span>{{ liveStreamDetails?.data?.type | titlecase }}</span>
		</div>
		<div class="line">
			<label>{{ "INGEST_TYPE" | translate }}</label>
			<span>{{ (liveStreamDetails?.data && (liveStreamDetails?.data['ingest-type'])) === 'rtmp' ? (liveStreamDetails?.data['ingest-type'] | uppercase) : ((liveStreamDetails?.data && liveStreamDetails?.data['ingest-type']) | titlecase) }}</span>
		</div>
		<div class="line" *ngIf="liveStreamDetails?.data && liveStreamDetails?.data['ingest-type'] === 'rtmp'">
			<label>{{ "INGEST_VARIANT" | translate }}</label>
			<span>{{ liveStreamDetails?.data && liveStreamDetails.data['ingest-variant'] | titlecase }}</span>
		</div>
		<div class="line">
			<label>{{ "STREAM_NAME" | translate }}</label>
			<span>{{ liveStreamDetails?.data && liveStreamDetails.data['stream-name'] }}</span>
		</div>
		<div class="line">
			<label>{{ "PAUSED" | translate }}</label>
			<bb-check [disabled]="!isRecordingFromStart && liveStreamDetails?.data?.recording" [(ngModel)]="isPaused" (onChanged)="onPausedChange($event)"></bb-check>
			<span class="text-only" class="gray" *ngIf="!isRecordingFromStart && liveStreamDetails?.data?.recording">{{'CANNOT_PAUSE_ON_NEW_RECORDING' | translate}}</span>
		</div>
		<div class="line" *ngIf="allowRecording">
			<label>{{ "RECORDING" | translate }}</label>
			<bb-check [disabled]="!isRecordingFromStart && isPaused" [(ngModel)]="liveStreamDetails.data.recording" (onChanged)="onRecordingChange($event)"></bb-check>
			<span class="text-only" class="gray" *ngIf="!isRecordingFromStart && isPaused">{{'CANNOT_START_RECORDING_ON_PAUSED_STREAMS' | translate}}</span>
		</div>
		<div class="line">
			<label>{{ "STREAM_URL" | translate }}</label>
			<span><a href="{{ liveStreamDetails?.data && liveStreamDetails.data['stream-url'] }}" target="_blank">{{ liveStreamDetails?.data && liveStreamDetails.data['stream-url'] }}</a></span>
		</div>
		<ng-container *ngIf="liveStreamDetails?.data?.ingest;">
			<h2>{{ "INGEST_DETAILS" | translate }}</h2>
			<!-- RTMP doesn't expose any (particularly) sensitive info in the URL-->
			<div class="line"
				*ngIf="(liveStreamDetails?.data && liveStreamDetails.data['ingest-type'] === 'rtmp') && (liveStreamDetails.data.ingest && liveStreamDetails.data.ingest[0] && liveStreamDetails.data.ingest[0].url)">
				<label>{{ "INGEST_URL" | translate }}</label>
				<span><a class="rtmp-ingest-url" (click)="copyToClipboard(liveStreamDetails.data.ingest[0].url)">{{ liveStreamDetails.data.ingest[0].url }}</a></span>
			</div>
			<div class="line"
				*ngIf="(allowBackupIngestFeed && liveStreamDetails?.data && liveStreamDetails.data['ingest-type'] === 'rtmp') && (liveStreamDetails.data.ingest && liveStreamDetails.data.ingest[0] && liveStreamDetails.data.ingest[0]['backup-url'])">
				<label>{{ "INGEST_BACKUP_URL" | translate }}</label>
				<span><a class="rtmp-ingest-url" (click)="copyToClipboard(liveStreamDetails.data.ingest[0]['backup-url'])">{{ liveStreamDetails.data.ingest[0]['backup-url'] }}</a></span>
			</div>
			<!-- Icecast and Webdav expose sensitive info in the URL -->
			<div class="line sensitive-line"
				*ngIf="(liveStreamDetails?.data && liveStreamDetails.data['ingest-type'] !== 'rtmp') && (liveStreamDetails.data.ingest && liveStreamDetails.data.ingest[0] && liveStreamDetails.data.ingest[0].url)">
				<label>{{ "INGEST_URL" | translate }}</label>
				<span>
					<a *ngIf="!showIngestUrl"><span>********************************</span></a>
					<a *ngIf="showIngestUrl" class="icecast-webdav-ingest-url"
						(click)="copyToClipboard(liveStreamDetails.data.ingest[0].url)">{{ liveStreamDetails.data.ingest[0].url }}</a>
					<button class="button toggle-visibility" (click)="toggleIngestUrlVisibility()"><i class="fa" [ngClass]="{'fa-eye-slash': showIngestUrl, 'fa-eye': !showIngestUrl}"></i> {{ (showIngestUrl ? "HIDE_INGEST_URL" : "SHOW_INGEST_URL") | translate }}</button>
				</span>
			</div>
			<div class="line sensitive-line"
				*ngIf="(allowBackupIngestFeed && liveStreamDetails?.data && liveStreamDetails.data['ingest-type'] !== 'rtmp') && (liveStreamDetails.data.ingest && liveStreamDetails.data.ingest[0] && liveStreamDetails.data.ingest[0]['backup-url'])">
				<label>{{ "INGEST_BACKUP_URL" | translate }}</label>
				<span>
					<a *ngIf="!showBackupIngestUrl"><span>********************************</span></a>
					<a *ngIf="showBackupIngestUrl" class="icecast-webdav-ingest-url"
						(click)="copyToClipboard(liveStreamDetails.data.ingest[0]['backup-url'])">{{ liveStreamDetails.data.ingest[0]['backup-url'] }}</a>
					<button class="button toggle-visibility" (click)="toggleBackupIngestUrlVisibility()"><i class="fa" [ngClass]="{'fa-eye-slash': showIngestUrl, 'fa-eye': !showIngestUrl}"></i> {{ (showIngestUrl ? "HIDE_INGEST_URL" : "SHOW_INGEST_URL") | translate }}</button>
				</span>
			</div>
			<ng-container *ngIf="(liveStreamDetails?.data && liveStreamDetails.data['ingest-type'] === 'rtmp') && liveStreamDetails.data.ingest">
				<div class="line sensitive-line" *ngFor="let ingestData of liveStreamDetails.data.ingest; let i = index;">
					<label>{{ "STREAM_KEY" | translate }}{{ liveStreamDetails.data.ingest.length > 1 ? " #" + (i + 1) + "" : "" }}</label>
					<span class="ingest-stream-key">
						<span *ngIf="showKey[i]">{{ ingestData['stream-name'] }}</span>
						<span *ngIf="!showKey[i]"><span *ngFor="let c of ingestData['stream-name'].split('')">*</span></span>
						<button class="button toggle-visibility" (click)="toggleKeyVisibility(i)"><i class="fa" [ngClass]="{'fa-eye-slash': showKey[i], 'fa-eye': !showKey[i]}"></i> {{ (showKey[i] ? "HIDE_STREAM_KEY" : "SHOW_STREAM_KEY") | translate }}</button>
						<button class="button icon-only" (click)="copyToClipboard(ingestData['stream-name'])"><i class="fa fa-copy"></i></button></span>
					</div>
			</ng-container>
		</ng-container>
	</div>
</ng-container>
